import { Injectable } from '@angular/core';

import { catchError, delay, filter, repeatWhen, tap } from 'rxjs/operators';
import { defer, Observable, of } from 'rxjs';

import { AppInsightsBaseService } from '@kros-sk/core/application-insights';
import { PermissionFullApiModel, PermissionPostApiModel } from '@kros-sk/models';

import { PermissionsApiService } from './permissions-api.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsDataService {

  constructor(
    private readonly permissionsApiService: PermissionsApiService,
    private readonly appInsights: AppInsightsBaseService
  ) { }

  loadPermissions(companyId: number, permissions: PermissionPostApiModel[]): Observable<PermissionFullApiModel[]> {
    let repeat = false;
    let maxRetries = 5;

    return defer(() => this.permissionsApiService.loadPermissions(companyId, permissions))
      .pipe(
        tap((data) => repeat = data?.length === 0),
        repeatWhen(notifier => notifier.pipe(
          tap(() => {
            if (repeat) {
              maxRetries--;
            }
          }),
          filter(() => repeat && maxRetries > 0),
          delay(5000))
        ),
        catchError(err => {
          this.appInsights.trackException(err, 'PermissionsDataService.loadPermissions', {
            companyId,
            permissionsToLoad: permissions,
            networkStatus: navigator.onLine
          });
          const fakedPermissions: PermissionFullApiModel[] = permissions.map(p => (
            {
              ...p,
              id: 0,
              userGroupId: 0,
              isAllowed: true,
              applicationType: p.applicationType
            }));
          return of(location.host.includes('.kros.sk') ? fakedPermissions : []);
        })
      );
  }
}
